export const SUPPORT_EMAIL = 'info@smileconsent.co.uk';

/**
 * mailto: query values must be percent-encoded (RFC 6068).
 * URLSearchParams uses `+` for spaces, which Outlook shows as literal pluses.
 */
function encodeMailtoValue(value) {
  return encodeURIComponent(value)
    .replace(/%0A/g, '%0D%0A')
    .replace(/'/g, '%27');
}

/**
 * Build a mailto link for clinic users contacting Smile Consent support.
 * Uses the plain support address (no display name) so email clients do not
 * show a stale clinic contact label in the To field.
 */
export function buildClinicSupportMailto({ clinicName, userName, userEmail } = {}) {
  const clinicLabel = clinicName?.trim() || 'My clinic';
  const subject = `Support request from ${clinicLabel}`;

  const bodyLines = [
    'Hello Smile Consent support team,',
    '',
    'I need help with:',
    '',
    '---',
    `Clinic: ${clinicLabel}`,
    userName ? `Name: ${userName}` : null,
    userEmail ? `Email: ${userEmail}` : null,
    '---',
  ].filter(Boolean);

  const body = bodyLines.join('\n');

  return `mailto:${SUPPORT_EMAIL}?subject=${encodeMailtoValue(subject)}&body=${encodeMailtoValue(body)}`;
}
